import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient instance.
 *
 * Shared between <QueryClientProvider> in App.tsx and Zustand stores
 * that need to invalidate queries outside of React component context
 * (e.g., after designStore.saveDesign()).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
